export default __webpack_public_path__ + "static/sketch-link-screenshot-ba70e832b0dd46a851e8e8b293b2b461.png";